import { render } from "./autocomplete2.vue?vue&type=template&id=b8b5312c"
import script from "./autocomplete2.vue?vue&type=script&lang=js"
export * from "./autocomplete2.vue?vue&type=script&lang=js"

import "./autocomplete2.vue?vue&type=style&index=0&id=b8b5312c&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__